import { render, staticRenderFns } from "./HandSubmit.vue?vue&type=template&id=11156dc9&scoped=true&"
import script from "./HandSubmit.vue?vue&type=script&lang=js&"
export * from "./HandSubmit.vue?vue&type=script&lang=js&"
import style0 from "./HandSubmit.vue?vue&type=style&index=0&id=11156dc9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11156dc9",
  null
  
)

export default component.exports